var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show && _vm.isMobile)?_c('div',{staticClass:"overlay",on:{"click":function($event){return _vm.$emit('overlay-click')}}},[_c('div',{staticClass:"text-container"},[_vm._v(" "+_vm._s(_vm.text)+" ")])]):(_vm.show)?_c('div',{staticClass:"text-container",style:(_vm.topLeft)},[_c('div',[_vm._v(" "+_vm._s(_vm.text)+" ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }